<div class='waiting' [ngClass]="{hidden: !_newsService.spinner}">
  <mat-spinner diameter="60"></mat-spinner>
</div>

<div class="container">

  <app-header-dialog [iconName]="'post_add'">
    {{ local_title }}
  </app-header-dialog>

  <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

    <mat-tab-group>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>post_add</mat-icon>
          <div>Notícia/New</div>
        </ng-template>

        <div class='tab-content-id'>

          <div class='checkbox'>
            <mat-checkbox color='primary' [formControl]="entityForm.controls.active">
              Ativo
            </mat-checkbox>
          </div>

          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Título</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.title"
              autocomplete="off">
            <mat-error *ngIf="entityForm.controls.title.hasError('required')">
              O titulo é obrigatório
            </mat-error>
          </mat-form-field>

          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Título En</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.title_en"
              autocomplete="off">
            <mat-error *ngIf="entityForm.controls.title_en.hasError('required')">
              Title is mandatory
            </mat-error>
          </mat-form-field>


          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Text Home</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.text_home"
              autocomplete="off">
            <mat-error *ngIf="entityForm.controls.title.hasError('required')">
              O texto home é obrigatório
            </mat-error>
          </mat-form-field>

          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Text Home En</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.text_home_en"
              autocomplete="off">
            <mat-error *ngIf="entityForm.controls.text_home_en.hasError('required')">
              O texto home é obrigatório
            </mat-error>
          </mat-form-field>


        </div>

      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>text_fields</mat-icon>
          <div>Texto Pt</div>
        </ng-template>


        <div class='tab-content'>
          <ckeditor
            [config]="{ 
                            toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList', '|', 'link', '|' ] }"
            [formControl]="entityForm.controls.text" [editor]="Editor"></ckeditor>
          <mat-error *ngIf="entityForm.controls.text.hasError('required')">
            O Texto é obrigatório
          </mat-error>
        </div>



      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>text_fields</mat-icon>
          <div>Texto En</div>
        </ng-template>


        <div class='tab-content'>
          <ckeditor
            [config]="{ 
                             toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'bulletedList', 'numberedList', '|', 'link', '|' ] }"
            [formControl]="entityForm.controls.text_en" [editor]="Editor"></ckeditor>
          <mat-error *ngIf="entityForm.controls.text_en.hasError('required')">
            The text is mandatory
          </mat-error>
        </div>

      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>image_search</mat-icon>
          <div>Imagens Pt</div>
        </ng-template>

        <div class='tab-content-img'>

          <div class='img-input'>
            <input #file type="file" accept='image/png, image/jpg' style='display:none'
              (change)="_newsService.previewImage($event)" />
          </div>
          <div class="post-image">
            <img [src]="_newsService.storedImage" *ngIf="_newsService.storedImage">
          </div>

          <div class="button-image">
            <button mat-raised-button (click)="remove_image('_pt')">
              <mat-icon class='icon-delete'>clear</mat-icon>
            </button>

            <button mat-raised-button (click)='file.click()'>
              <mat-icon class='icon-add'>image_search</mat-icon>
            </button>

          </div>

        </div>

      </mat-tab>


      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>image_search</mat-icon>
          <div>Imagens En</div>
        </ng-template>

        <div class='tab-content-img'>

          <div class='img-input'>
            <input #file_en type="file" accept='image/png, image/jpg' style='display:none'
              (change)="_newsService.previewImage_en($event)" />
          </div>
          <div class="post-image">
            <img [src]="_newsService.storedImage_en" *ngIf="_newsService.storedImage_en">
          </div>
          <div class="button-image">
            <button mat-raised-button (click)="remove_image('_en')">
              <mat-icon class='icon-delete'>clear</mat-icon>
            </button>

            <button mat-raised-button (click)='file_en.click()'>
              <mat-icon class='icon-add'>image_search</mat-icon>
            </button>

          </div>

        </div>

      </mat-tab>

    </mat-tab-group>

  </form>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <button mat-raised-button (click)='insert()' [disabled]="entityForm.invalid" *ngIf="!isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
    <button mat-raised-button (click)='update()' [disabled]="entityForm.invalid" *ngIf="isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
  </div>

</div>